import { apiUrl } from "../utils/api";

/**
 * Ordner in der Alten Kundenakte eines Kontakts (PO 28.09.2026) —
 * `/api/kundenakte-ordner`.
 *
 * Ein Ordner ist ein Präfix in `Document.fileName`; Umbenennen und Verschieben
 * schreiben die Pfade aller Dateien darunter um. Nur leere Ordner haben eine
 * eigene Zeile — deshalb liefert `liste` auch nur die, die jemand angelegt hat.
 */

const post = async <T>(pfad: string, body: unknown): Promise<T> => {
    const res = await fetch(apiUrl(pfad), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
    });
    if (!res.ok) {
        // Die Meldungen des Servers sind deutsch und für den Nutzer gedacht
        // („Der neue Pfad wäre … zu lang.").
        const text = await res.text().catch(() => "");
        let meldung = "";
        try {
            meldung = String((JSON.parse(text) as { message?: unknown }).message ?? "");
        } catch {
            meldung = "";
        }
        throw new Error(meldung || (res.status === 403 ? "Keine Schreibrechte auf diesen Kontakt." : `Fehler (HTTP ${res.status}).`));
    }
    return res.json() as Promise<T>;
};

export const kundenakteOrdnerService = {
    async liste(contactId: number, signal?: AbortSignal): Promise<string[]> {
        const res = await fetch(apiUrl("kundenakte-ordner", { contactId: String(contactId) }), { signal });
        if (!res.ok) throw new Error(`Ordner konnten nicht geladen werden (${res.status})`);
        return res.json();
    },
    anlegen: (contactId: number, pfad: string) =>
        post<{ pfad: string }>("kundenakte-ordner", { contactId, pfad }),
    verschieben: (contactId: number, von: string, nach: string) =>
        post<{ dateien: number }>("kundenakte-ordner/verschieben", { contactId, von, nach }),
    loeschen: (contactId: number, pfad: string) =>
        post<{ dateien: number }>("kundenakte-ordner/loeschen", { contactId, pfad }),
};
